<template>
    <v-dialog v-model="dialogOpen" :persistent="true" max-width="800">

        <v-card color="#303030" v-if="dialogOpen">

            <toolbar-page title="Standard variables" icon="mdi-database">
                <template slot="buttons">

                    <v-tooltip color="primary" top>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="closeDialog()" v-on="on" icon>
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Close this dialog</span>
                    </v-tooltip>

                </template>
            </toolbar-page>

            <v-progress-linear :color="loading ? 'primary' : '#303030'" height="5" :indeterminate="loading"></v-progress-linear>

            <v-skeleton-loader v-show="loading && standardVariables.length === 0"
                               type="list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line, list-item-avatar-three-line">
            </v-skeleton-loader>

            <v-card-text v-if="standardVariables.length > 0">

                <v-expansion-panels class="mt-3" v-for="variable in standardVariables" :key="variable.label">

                    <v-expansion-panel>

                        <v-expansion-panel-header class="pa-2" color="grey darken-3">

                            <div class="d-flex justify-space-between">
                                <div class="align-self-center">
                                    <v-icon class="ml-2 mr-2">{{ getIcon(variable.type) }}</v-icon>
                                    {{ variable.name }}
                                </div>

                                <v-scale-transition>
                                    <v-btn class="align-self-center mr-4"
                                           v-show="!variableExists(variable.name)"
                                           width="100"
                                           small
                                           color="primary" :loading="creating === variable.name"
                                           @click.stop="createClicked(variable.name)">
                                        Create
                                    </v-btn>
                                </v-scale-transition>

                                <v-scale-transition>

                                    <v-chip color="green darken-2 elevation-0" small class="mr-4">
                                        <v-icon v-show="variableExists(variable.name)"
                                                class="mr-1"
                                                small
                                                color="white">mdi-check
                                        </v-icon>
                                        CREATED
                                    </v-chip>

                                </v-scale-transition>
                            </div>

                        </v-expansion-panel-header>

                        <v-expansion-panel-content :disabled="variable.type !== 'radio' && variable.type !== 'checkbox'">

                            <div class="pb-4">
                                {{ variable.question_text }}
                            </div>

                            <div class="d-flex justify-start pb-1"
                                 v-for="(option,index) in variable.options"
                                 :key="variable.name + '_' + option.id">

                                <v-card width="50" flat class="align-self-center">
                                    <v-chip>{{ option.id }}</v-chip>
                                </v-card>
                                <div class="align-self-center ml-2">
                                    {{ option.value }}
                                </div>
                            </div>


                        </v-expansion-panel-content>
                    </v-expansion-panel>


                </v-expansion-panels>

                <json v-if="false" :data="standardVariables"/>

            </v-card-text>
        </v-card>
    </v-dialog>

</template>

<script>

import ToolbarPage from '../../../components/UI/ToolbarPage';
import {mapState, mapActions} from 'vuex';
import Json from 'vue-json-pretty';
import DataVariableChip from "../../../components/UI/DataVariableChip";

const vuexModule = 'DataVariables';

export default {

    components: {
        DataVariableChip,
        ToolbarPage,
        Json
    },

    props: {
        value: {
            type: Boolean,
            required: true,
        }
    },

    data() {
        return {
            creating: null,
            loading: false,
        }
    },

    watch: {
        value(value) {
            if (value) {
                this.loadStandardVariable();
            }
        }
    },

    computed: {
        dialogOpen: {
            get() {
                return this.value;
            },
            set() {
                this.closeDialog();
            }
        },

        ...mapState([
            'dataVariables'
        ]),

        ...mapState(vuexModule, [
            'standardVariables'
        ])
    },

    methods: {

        ...mapActions(vuexModule, [
            "getStandardVariables",
            "createStandardVariable"
        ]),

        variableExists(name) {
            return !!this.dataVariables.find(variable => variable.name === name);
        },

        createClicked(name) {
            this.creating = name;

            this.createStandardVariable(name)
                .then(response => {
                    Bus.$emit('flash-message', {
                        message: "Standard variable " + name + " created!"
                    });
                })
                .catch(error => {

                    if (error.response.status === 409) {
                        Bus.$emit('flash-message', {
                            type: 'error',
                            message: "Variable with label " + name + " already exists"
                        });
                    } else if (error.response.status === 404) {
                        Bus.$emit('flash-message', {
                            type: 'error',
                            message: 'Unknown standard variable. Create failed.'
                        });
                    } else {
                        Bus.$emit('flash-message', {
                            type: 'error',
                            message: 'OOPS We failed to create standard variables.. Try again later...'
                        });
                    }
                })
                .finally(() => {
                    this.creating = null;
                });
        },

        closeDialog() {
            this.$emit('input', false);
        },

        getIcon(type) {
            return this.$store.state.dataVariableIcons[type];
        },

        loadStandardVariable() {
            this.loading = true;

            this.getStandardVariables()
                .catch(error => {
                    Bus.$emit('flash-message', {
                        type: 'error',
                        message: 'OOPS We failed to get the standard variables.. Try again later...'
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
}
</script>
